<template>
  <v-combobox
    dense
    v-model="selected"
    :items="items"
    small-chips
    :label="$t('selectTransitions')"
    :hint="$t('selectTransitionsHint')"
    persistent-hint
    item-text="display"
    hide-no-data
    hide-selected
    multiple
    :menu-props="{
      closeOnContentClick: true
    }"
  >
    <template slot="selection" slot-scope="{ selected, item }">
      <v-chip :selected="selected" close small @input="remove(item)">
        {{ item.display }}
      </v-chip>
    </template>
  </v-combobox>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { NAMESPACE } from '../store'
export default {
  props: {
    selection: Array,
    updateSelection: Function
  },
  computed: {
    ...mapState(NAMESPACE, ['current']),
    items() {
      return this.current.meta.transitions
    },
    selected: {
      get() {
        return this.selection.map((option) => this.items.find((item) => item.name === option.name))
      },
      set(value) {
        this.updateSelection(value)
      }
    }
  },
  methods: {
    remove(option) {
      this.selected = this.selected.filter((item) => item.name !== option.name)
    }
  }
}
</script>

<i18n>
{
  "en": {
    "selectTransitions": "Select Transitions",
    "selectTransitionsHint": "Add this element to all the selected transitions"
  },
  "fr": {
    "selectTransitions": "Choisir les transitions",
    "selectTransitionsHint": "Ajouter cet élément à toutes les transitions choisies"
  }
}
</i18n>
